module.exports = {
  schema: {
    name: 'A類顏色',
    type: 'Object',
    contents: {
      ragicId: {
        type: 'Number',
        ragicId: '_ragicId',
        name: 'RagicId',
        disable: true,
      },
      key: {
        type: 'String',
        name: '顏色',
        unique: true,
        ragicId: '1000118',
      },
      description: {
        type: 'String',
        name: '描述',
        ragicId: '1000488',
      },
      ragicStoreNodeId: {
        type: 'Number',
        name: 'Ragic門市資料Id',
        noclone: true,
      },
      ragicCenterNodeId: {
        type: 'Number',
        name: 'Ragic管理中心資料Id',
        noclone: true,
      },
      syncCenterAt: {
        type: 'Date',
        name: '上次同步管理中心時間',
      },
      syncStoreAt: {
        type: 'Date',
        name: '上次同步門市時間',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'description', width: 130 },
        { key: 'ragicCenterNodeId', width: 100 },
        { key: 'ragicStoreNodeId', width: 100 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: 'A類商品顏色',
          rows: [
            [{ key: 'key' }],
            [{ key: 'description' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/typeAColors.js